import axios from "axios";
import { SHOP_API_BASE_URL, SECURE_API_BASE_URL } from "./apis";

export const axiosAuthInstance = axios.create({
    baseURL: SECURE_API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
});

export const axiosPublicInstance = axios.create({
    baseURL: SHOP_API_BASE_URL,
    headers: {
        "Content-type": "application/json",
    },
});

export const setupInterceptors = () => {
    if (!axiosAuthInstance) {
        console.error("axiosAuth is not initialized.");
        return;
    }
    axiosAuthInstance.interceptors?.request?.use(
        (config: any) => {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error: any) => Promise.reject(error)
    );

    axiosAuthInstance.interceptors?.response?.use(
        (response: any) => {
            //console.log("Response Interceptor Triggered!", response);
            if (!response.data || Object.keys(response.data).length === 0) {
                console.warn("Empty response received, redirecting to login...");
            }
            return response;
        },
        (error: any) => {
            console.log("Error Interceptor Triggered!", error);
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                console.warn("Redirecting to login...");
                localStorage.clear();
                window.location.href = "/login";
                return Promise.reject("Unauthorized");
            }
            return Promise.reject(error);
        }
    );
};



